/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Funnel_Pw_Check3Inputs */

const en_funnel_pw_check3 = /** @type {(inputs: Funnel_Pw_Check3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`One subscription for web, desktop, iPhone, and Android`)
};

const es_funnel_pw_check3 = /** @type {(inputs: Funnel_Pw_Check3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Una suscripción para web, escritorio, iPhone y Android`)
};

/**
* | output |
* | --- |
* | "One subscription for web, desktop, iPhone, and Android" |
*
* @param {Funnel_Pw_Check3Inputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const funnel_pw_check3 = /** @type {((inputs?: Funnel_Pw_Check3Inputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Funnel_Pw_Check3Inputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_funnel_pw_check3(inputs)
	return en_funnel_pw_check3(inputs)
});